import React, { memo, useContext, useState } from "react";
import Select from "react-select";

import Filters from "../../components/Filters";
import { DefaultButton } from "../../style/default";
import { customStyles } from "../../style/selectStyles";
import { NumberOfficialMonitorContext } from "../../context/numberOfficialMonitorData";

const NumberOfficialMonitorFilter = ({
	populateNumber,
	handleAllFilters,
	className,
	filterType,
	clientsSelect,
}) => {
	//VARIABLES
	const { monitorOfficialFilter, setMonitorOfficialFilter } = useContext(
		NumberOfficialMonitorContext
	);
	const [setorSelected, setSelectedSetor] = useState(
		monitorOfficialFilter.sector
	);
	const [clientSelected, setSelectedClient] = useState(
		monitorOfficialFilter.client
	);
	const [number, setNumber] = useState(monitorOfficialFilter.number);

	const [isScreenLock, setLockScreen] = useState(false);

	const handleSearch = () => {
		const obj = {
			sector: setorSelected,
			client: clientSelected.value,
			number: number,
		};
		setMonitorOfficialFilter({
			sector: setorSelected,
			client: clientSelected,
			number: number,
		});

		populateNumber(obj);
		handleAllFilters();
		setLockScreen(false);
	};

	const cleanSearch = () => {
		setSelectedSetor({ label: "", value: "" });
		setSelectedClient({ label: "", value: "" });
		setNumber("");

		setMonitorOfficialFilter({
			sector: "",
			server: { label: "", value: "" },
			client: { label: "", value: "" },
			number: "",
		});

		populateNumber({
			sector: "",
			server: { label: "", value: "" },
			client: { label: "", value: "" },
			number: "",
		});
		handleAllFilters();
		setLockScreen(false);
	};

	return (
		<Filters
			filterType={filterType}
			handleAllFilters={handleAllFilters}
			className={className}
			isScreenLock={isScreenLock}
		>
			<div>
				<label>Cliente</label>
				<Select
					styles={customStyles}
					options={clientsSelect}
					onChange={(e) => setSelectedClient(e)}
					value={clientSelected?.value ? clientSelected : ""}
					placeholder="Cliente"
				/>
			</div>
			<div>
				<label>Número</label>
				<input
					placeholder="Pesquisar por número"
					onChange={(e) => setNumber(e.target.value)}
					value={number}
				/>
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<DefaultButton onClick={() => handleSearch()}>Pesquisar</DefaultButton>
				<DefaultButton
					onClick={() => cleanSearch()}
					style={{ marginLeft: "1rem" }}
				>
					Limpar Filtros
				</DefaultButton>
			</div>
		</Filters>
	);
};

export default memo(NumberOfficialMonitorFilter);
